import React, {Fragment} from "react";
import Profile from "../profilecomponents/profile";
import Education from "../profilecomponents/education";
import Experience from "../profilecomponents/expereince";


const JobseekerProfile = () => {
  return (
    <Fragment>
    
      <Profile />

      <Education />

      <Experience />

     
    </Fragment>
  );
};

export default JobseekerProfile;
